export default __webpack_public_path__ + "static/media/IMG_4523-min.657a2056.JPG";